var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticStyle:{"padding-left":"15px","padding-bottom":"10px"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.cmsOfferRequested.content)}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }